'use client';

import { Layers } from 'lucide-react';

/**
 * L'affordance «esplodi per POD» nell'intestazione di una card.
 *
 * Sta nello slot `aside` di `PanelCard`, accanto a `CalcTrace`: quella icona
 * risponde a «come è calcolato questo numero», questa a «di chi è». Le due
 * insieme sono il corredo standard di un KPI, e tenerle nello stesso posto su
 * ogni pannello è ciò che rende l'esploso una cosa che si cerca per abitudine
 * invece che per scoperta.
 *
 * Riceve solo un'intenzione: il dato, la finestra temporale e la metrica li
 * conosce il cablaggio che la monta.
 */
export interface ExplodeButtonProps {
	/** Etichetta accessibile, es. «Esplodi il consumo mensile per POD». */
	label: string;
	onClick: () => void;
	/**
	 * Disattivato quando la metrica non ha dati da scomporre. Il bottone resta
	 * visibile: nasconderlo farebbe sembrare l'esploso una funzione che su quel
	 * pannello non esiste, invece di una che ora non ha dati.
	 */
	disabled?: boolean;
	/** Motivo del disabilitato, mostrato come tooltip nativo. */
	disabledReason?: string;
}

export function ExplodeButton({ label, onClick, disabled, disabledReason }: ExplodeButtonProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			aria-label={label}
			title={disabled ? (disabledReason ?? label) : label}
			className="inline-flex size-6 shrink-0 items-center justify-center rounded-md text-fg-secondary transition-colors hover:bg-bg-secondary hover:text-fg focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-1 disabled:pointer-events-none disabled:opacity-35"
		>
			<Layers className="size-3.5" aria-hidden />
		</button>
	);
}
